import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Process } from '../../components/process/process';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useIrzFacilitySplit } from './irz-facility-split-hook';
import { ProcessForm } from './irz-facility-split-types';
import { TranslationKeys } from '../../enums';

const useStyles = makeStyles(() =>
  createStyles({
    loaderWrapper: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      padding: '10px',
    },
  })
);

export function IrzFacilitySplit() {
  const classes = useStyles();

  const { steps, isLoading } = useIrzFacilitySplit();

  return isLoading ? (
    <div className={classes.loaderWrapper}>
      <CircularProgress />
    </div>
  ) : (
    <Process<ProcessForm>
      title="Rozdělení provozovny IRZ"
      steps={steps}
      translationKey={TranslationKeys.IRZ_FACILITY_SPLIT}
    />
  );
}
